import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconOpenAi20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconOpenAi20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M16.945 8.549a3.94 3.94 0 0 0-.347-3.274 4.11 4.11 0 0 0-4.4-1.934A4.07 4.07 0 0 0 9.15 2C7.375 1.995 5.8 3.123 5.253 4.79a4.04 4.04 0 0 0-2.701 1.934 3.99 3.99 0 0 0 .503 4.727 3.94 3.94 0 0 0 .347 3.274 4.11 4.11 0 0 0 4.4 1.934A4.06 4.06 0 0 0 10.849 18c1.777.004 3.352-1.125 3.899-2.793a4.04 4.04 0 0 0 2.701-1.934 3.99 3.99 0 0 0-.504-4.725m-6.095 8.405a3.05 3.05 0 0 1-1.945-.694c.025-.013.068-.036.095-.053l3.23-1.84a.52.52 0 0 0 .265-.454v-4.49l1.365.777a.05.05 0 0 1 .026.037v3.72c-.002 1.654-1.36 2.995-3.036 2.998m-6.529-2.751a2.95 2.95 0 0 1-.362-2.01l.096.057 3.229 1.84a.53.53 0 0 0 .53 0l3.942-2.246V13.4a.05.05 0 0 1-.02.042L8.474 15.3c-1.454.825-3.31.334-4.151-1.098m-.85-6.955a3.02 3.02 0 0 1 1.582-1.314l-.001.11v3.68c-.001.187.1.36.265.453l3.941 2.246-1.364.777a.05.05 0 0 1-.046.004l-3.265-1.86a2.98 2.98 0 0 1-1.112-4.095m11.212 2.575-3.941-2.246 1.364-.777a.05.05 0 0 1 .046-.004l3.265 1.86a2.98 2.98 0 0 1 1.111 4.096 3.03 3.03 0 0 1-1.58 1.314v-3.79a.52.52 0 0 0-.264-.453m1.358-2.017-.095-.057-3.23-1.84a.53.53 0 0 0-.53 0L8.244 8.155V6.6a.05.05 0 0 1 .02-.041L11.528 4.7c1.453-.828 3.312-.335 4.15 1.1.354.606.482 1.315.362 2.005zm-8.538 2.771L6.137 9.8a.05.05 0 0 1-.026-.037v-3.72c.001-1.656 1.363-2.998 3.041-2.997.71 0 1.397.246 1.943.694l-.096.054-3.229 1.84a.52.52 0 0 0-.265.453zM8.243 9 10 8l1.755 1v2L10 12l-1.756-1z"
            />
        </svg>
    );
}
export default memo(IconOpenAi20);
